// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs__container--2E6","tabs":"Tabs__tabs--1p8","tab":"Tabs__tab--1Oz"};